/**
 * Renderer exports and factory
 * Requirements: 6.1-6.5
 */

import { GridType } from '@langton/shared';
import type { IRenderer } from '@langton/shared';
import { SquareRenderer } from './square-renderer';
import { TriangularRenderer } from './triangular-renderer';
import { HexagonalRenderer } from './hexagonal-renderer';

export { BaseRenderer } from './base-renderer';
export { SquareRenderer } from './square-renderer';
export { TriangularRenderer } from './triangular-renderer';
export { HexagonalRenderer } from './hexagonal-renderer';
export * from './avatar-renderer';
export * from './tiled-renderer';

/**
 * Factory function to create appropriate renderer for grid type
 */
export function createRenderer(gridType: GridType): IRenderer {
  switch (gridType) {
    case GridType.Square:
      return new SquareRenderer();
    case GridType.Triangular:
      return new TriangularRenderer();
    case GridType.Hexagonal:
      return new HexagonalRenderer();
    default:
      throw new Error(`Unknown grid type: ${gridType}`);
  }
}
